export default __webpack_public_path__ + "static/media/icons8-facebook.dd1ca143.svg";